export const REGION_META = {
  in: { label: "India", color: "var(--coral)", soft: "var(--coral-soft)", fill: "var(--fill-in)" },
  me: { label: "Middle East", color: "var(--saffron)", soft: "var(--saffron-soft)", fill: "var(--fill-me)" },
  af: { label: "Africa", color: "var(--emerald)", soft: "var(--emerald-soft)", fill: "var(--fill-af)" },
};

export const markets = [
  {
    name: "India", region: "in", subRegion: "South Asia", iso: "356",
    cities: [
      { name: "Mumbai", coords: [72.88, 19.08], hub: true, label: "right" },
      { name: "Delhi", coords: [77.21, 28.61], label: "right" },
      { name: "Bengaluru", coords: [77.59, 12.97] },
    ],
  },
  {
    name: "United Arab Emirates", region: "me", subRegion: "Middle East", iso: "784",
    cities: [
      { name: "Dubai", coords: [55.27, 25.2], hub: true, label: "right" },
      { name: "Abu Dhabi", coords: [54.38, 24.45] },
    ],
  },
  { name: "Oman", region: "me", subRegion: "Middle East", iso: "512", cities: [{ name: "Muscat", coords: [58.41, 23.59] }] },
  {
    name: "Kenya", region: "af", subRegion: "East Africa", iso: "404",
    cities: [{ name: "Nairobi", coords: [36.82, -1.29], hub: true, label: "right" }],
  },
  { name: "Tanzania", region: "af", subRegion: "East Africa", iso: "834", cities: [{ name: "Dar es Salaam", coords: [39.21, -6.79] }] },
  { name: "Uganda", region: "af", subRegion: "East Africa", iso: "800", cities: [{ name: "Kampala", coords: [32.58, 0.35] }] },
  { name: "Rwanda", region: "af", subRegion: "East Africa", iso: "646", cities: [{ name: "Kigali", coords: [30.06, -1.95] }] },
  { name: "Burundi", region: "af", subRegion: "East Africa", iso: "108", cities: [{ name: "Bujumbura", coords: [29.36, -3.38] }] },
  { name: "South Sudan", region: "af", subRegion: "East Africa", iso: "728", cities: [{ name: "Juba", coords: [31.58, 4.85] }] },
  {
    name: "Somalia", region: "af", subRegion: "East Africa", iso: "706",
    cities: [{ name: "Mogadishu", coords: [45.32, 2.05], label: "right" }],
  },
  {
    name: "DR Congo", region: "af", subRegion: "Central Africa", iso: "180",
    cities: [{ name: "Kinshasa", coords: [15.27, -4.44], hub: true, label: "left" }],
  },
  {
    name: "Chad", region: "af", subRegion: "Central Africa", iso: "148",
    cities: [{ name: "N'Djamena", coords: [15.04, 12.13], label: "right" }],
  },
  {
    name: "Nigeria", region: "af", subRegion: "West Africa", iso: "566",
    cities: [{ name: "Lagos", coords: [3.38, 6.52], hub: true, label: "below", ldy: 3 }],
  },
  { name: "Ghana", region: "af", subRegion: "West Africa", iso: "288", cities: [{ name: "Accra", coords: [-0.19, 5.6] }] },
  {
    name: "Liberia", region: "af", subRegion: "West Africa", iso: "430",
    cities: [{ name: "Monrovia", coords: [-10.8, 6.3], label: "right", ldy: -12 }],
  },
  { name: "Burkina Faso", region: "af", subRegion: "West Africa", iso: "854", cities: [{ name: "Ouagadougou", coords: [-1.53, 12.37] }] },
  { name: "Niger", region: "af", subRegion: "West Africa", iso: "562", cities: [{ name: "Niamey", coords: [2.11, 13.51] }] },
  {
    name: "South Africa", region: "af", subRegion: "Southern Africa", iso: "710",
    cities: [{ name: "Johannesburg", coords: [28.05, -26.2], hub: true, label: "left" }],
  },
  { name: "Botswana", region: "af", subRegion: "Southern Africa", iso: "072", cities: [{ name: "Gaborone", coords: [25.91, -24.65] }] },
  { name: "Mozambique", region: "af", subRegion: "Southern Africa", iso: "508", cities: [{ name: "Maputo", coords: [32.57, -25.97] }] },
];
